import { gql } from 'graphql-request';

const request = {
	request: {
		name: 'webshop>checkout'
	},

	gql: {
		schema: gql`
			query Checkout {
			  request {
			    access_token
			  }
			}
		`
	}
};

export default request;
